<template>
    <form>
        <action-button
            :disabled="! mutableData.language_id"
            method="get"
            class="float-xl-end me-2"
            :endpoint="`/admin/api/components/${componentId}/translate`"
            :body="{ language_id: mutableData.language_id, formality: 'less' }"
            @actioned="displayTranslation"
            @failed="displayError"
            title="Auto translate (informal)"
        >
            Translate (informal)
        </action-button>

        <action-button
            :disabled="! mutableData.language_id"
            method="get"
            class="float-xl-end me-2"
            :endpoint="`/admin/api/components/${componentId}/translate`"
            :body="{ language_id: mutableData.language_id, formality: 'more' }"
            @actioned="displayTranslation"
            @failed="displayError"
            title="Auto translate (formal)"
        >
            Translate (formal)
        </action-button>

        <action-button
            :disabled="! mutableData.language_id"
            method="get"
            class="float-xl-end me-2"
            :endpoint="`/admin/api/components/${componentId}/translate`"
            :body="{ language_id: mutableData.language_id, formality: 'default' }"
            @actioned="displayTranslation"
            @failed="displayError"
            title="Auto translate (default)"
        >
            Translate
        </action-button>

        <h4>
Translation
</h4>

        <form-alert />

        <div class="form-group">
            <label>
                Type
            </label>
            <input
                type="text"
                disabled
                :value="componentType"
                class="form-control"
            />
        </div>

        <div class="form-group">
            <label for="language_id">
                Language
            </label>
            <form-select
                v-model="mutableData.language_id"
                name="language_id"
                endpoint="/admin/api/languages-options"
                data-vv-as="Language"
            />
        </div>

        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label for="title">
                        Title
                    </label>
                    <form-input
                        v-model="mutableData.title"
                        name="title"
                        data-vv-as="Title"
                    />
                </div>
            </div>
        </div>

        <div class="form-group">
            <label for="content">
                Content
            </label>
            <trumbowyg
                v-model="mutableData.content"
                :model-value="mutableData.content"
                :config="config"
                class="form-control"
                name="content"
                data-vv-as="Content"
            />
        </div>

        <form-alert />

        <button
            :disabled="isSending"
            class="btn btn-success btn-block"
            @click.prevent="submitForm()"
        >
            Save
        </button>
    </form>
</template>

<script>
import Swal from "sweetalert2";
import Form from "../mixins/Form.js";
import Trumbowyg from "../mixins/Trumbowyg.js";
import ActionButton from "./ActionButton.vue";
import useClipboard from "vue-clipboard3";

export default {
  components: {
    ActionButton,
  },

  mixins: [
    Form,
    Trumbowyg,
  ],

  props: {
    componentId: {
      type: Number,
      required: true,
    },

    componentType: {
      type: String,
      required: true,
    },
  },

    setup() {
        const { toClipboard } = useClipboard();

        return {
            toClipboard,
        }
    },

  methods: {
    async displayTranslation(data) {
        let html = "<hr />";
        let text = "";

        for (const i in data.translations) {
            html += `${data.translations[i].text}<br />`;
            text += `${data.translations[i].text}\n`;
        }

        // copy translation to clipboard
        try {
            await this.toClipboard(text);
        } catch (e) {
            console.error(e);
            alert("Unable to copy text to clipboard");
        }

        // display translation
        Swal.fire({
            title: "This translation has been copied to your clipboard",
            html,
            width: "70%",
        });
    },
    displayError(error) {
      Swal.fire({
        title: "Error",
        text: error.response.data.message,
      });
    },
  },
};
</script>
